import { TextField } from '@mui/material';

interface IntrospectionEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function IntrospectionEndpointField({
  value,
  error,
  setValue,
}: IntrospectionEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Introspection Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default IntrospectionEndpointField;

